import { FormControl, FormGroup } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
// import Trix from "trix"

@Component({
    selector: 'libs-trix',
    template: `
        <form [formGroup]="form">
            <input id="x" type="hidden" name="content" formControlName="content" />
            <trix-editor input="x"></trix-editor>
        </form>

        <!-- <quill-editor [modules]="modules" [formats]="formats"></quill-editor> -->
        <button (click)="onSave()">Save</button>
    `,
    styleUrls: ['./trix.component.scss'],
    standalone: false,
})
export class TrixComponent implements OnInit {
    @ViewChild('trix', { static: true }) trix: any;

    public form = new FormGroup({
        content: new FormControl('hello there'),
    });

    constructor() {
        // Trix.config.attachments.preview.caption = {
        //     name: false,
        //     size: false
        // };
        document.addEventListener('trix-before-initialize', () => {
            console.log('trix-before-initialize');
            // Change Trix.config if you need
        });
    }

    public ngOnInit(): void {
        // document.addEventListener("trix-before-initialize", () => {
        //     // Change Trix.config if you need
        // });

        setTimeout(() => {
            console.log('local trix:', this.trix);
        });
    }

    public onSave() {
        console.log('form value:', this.form.value);
    }
}
